import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, doc, setDoc, updateDoc, where, deleteDoc, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase';
import { matchesSearch } from '../utils/searchText';
import ListPagination from '../components/ListPagination';
import { Modal, Box, Typography, Button, Alert, TextField, Select, MenuItem, useMediaQuery, useTheme } from '@mui/material';

function FirmaListesi({ sube }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [firmalar, setFirmalar] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedFirma, setSelectedFirma] = useState(null);
  const [islemler, setIslemler] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    sube: '',
    firmaIsmi: '',
    vergiNo: '',
    iletisimNo: '',
    adres: '',
    firmaBilgileri: ''
  });

  // --- YENİ EKLENEN STATE: Silme onayı için ---
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

  const [selectedIslem, setSelectedIslem] = useState(null);
  const [editForm, setEditForm] = useState(null);
  const [isIslemEditing, setIsIslemEditing] = useState(false);
  const [islemSuccess, setIslemSuccess] = useState('');
  const [islemError, setIslemError] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const itemsPerPage = isMobile ? 8 : 10;

  const kategoriler = ['Sarrafiye', 'Gram Altın', 'Takı Ürün', 'Hurda', 'Döviz', 'Genel'];
  const islemTurleri = ['Alış', 'Satış', 'Giriş', 'Çıkış', 'İade', 'Değişim'];
  const urunlerListesi = {
    Sarrafiye: [
      'Eski Ziynet Çeyrek', 'Yeni Ziynet Çeyrek', 'Eski Ziynet Yarım', 'Yeni Ziynet Yarım',
      'Eski Ziynet Tam', 'Yeni Ziynet Tam', "Eski Ziynet 2.5'lu Gremse", "Yeni Ziynet 2.5'lu Gremse",
      'Eski Ziynet Beşli', 'Yeni Ziynet Beşli', 'Cumhuriyet Ata Çeyrek', 'Cumhuriyet Ata Yarım',
      'Cumhuriyet Ata', "Cumhuriyet Ata 2.5'lu", 'Cumhuriyet Ata Beşli', 'Reşat Çeyrek',
      'Reşat Yarım', 'Reşat', "Reşat 2.5'lu", 'Reşat Beşli'
    ],
    'Gram Altın': [
      '1 Gram 22 Ayar', '0.50 Gram 22 Ayar', '0.25 Gram 22 Ayar', '1 Gram 24 Ayar',
      '0.50 Gram 24 Ayar', '0.25 Gram 24 Ayar', '2.50 Gram 24 Ayar', '5 Gram 24 Ayar',
      '10 Gram 24 Ayar', '20 Gram 24 Ayar', '50 Gram 24 Ayar', '100 Gram 24 Ayar'
    ],
    'Takı Ürün': [
      '22 Ayar Bilezik', '14 Ayar Bilezik', '8 Ayar Bilezik', '22 Ayar Takı',
      '21 Ayar Takı', '18 Ayar Takı', '14 Ayar Takı', '8 Ayar Takı'
    ],
    Hurda: [
      '24 Ayar Hurda', '22 Ayar Bilezik Hurda', '22 Ayar Hurda', '21 Ayar Hurda',
      '18 Ayar Hurda', '14 Ayar Hurda', '8 Ayar Hurda'
    ],
    Döviz: [
      'TL - Türk Lirası', 'USD - Amerikan Doları', 'EUR - Euro', 'GBP - İngiliz Sterlini',
      'CHF - İsviçre Frangı', 'AUD - Avustralya Doları', 'CAD - Kanada Doları',
      'SAR - Suudi Arabistan Riyali', 'AED - Birleşik Arap Emirlikleri Dirhemi',
      'QAR - Katar Riyali', 'MAD - Fas Dirhemi', 'JOD - Ürdün Dinarı',
      'KWD - Kuveyt Dinarı', 'CNY - Çin Yuanı', 'RUB - Rus Rublesi', 'BGN - Bulgar Levası'
    ],
    Genel: []
  };

  useEffect(() => {
    console.log('FirmaListesi render edildi, sube:', sube);
    const q = query(collection(db, 'subeler', sube, 'firmalar'), orderBy('timestamp', 'desc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc, index) => ({ id: doc.id, no: index + 1, ...doc.data() }));
      setFirmalar(data);
    }, (err) => {
      setError(`Firma listesi alınamadı: ${err.message}`);
    });
    return unsubscribe;
  }, [sube]);

  const filteredFirmalar = firmalar.filter((firma) => {
    const firmaIsmi = firma.firmaIsmi || '';
    const vergiNo = firma.vergiNo || '';
    const iletisim = firma.iletisimNo || '';
    return matchesSearch(searchTerm, firmaIsmi, vergiNo, iletisim);
  });

  const pageCount = Math.ceil(filteredFirmalar.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredFirmalar.slice(offset, offset + itemsPerPage);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) {
      return { tarih: 'Belirtilmemiş', saat: 'Belirtilmemiş' };
    }
    let date;
    if (typeof timestamp === 'string') {
      try {
        date = new Date(timestamp);
      } catch (e) {
        return { tarih: 'Geçersiz Tarih', saat: 'Geçersiz Saat' };
      }
    } else if (timestamp && typeof timestamp === 'object' && 'seconds' in timestamp) {
      date = new Date(timestamp.seconds * 1000 + (timestamp.nanoseconds / 1000000));
    } else {
      return { tarih: 'Belirtilmemiş', saat: 'Belirtilmemiş' };
    }
    if (isNaN(date.getTime())) {
      return { tarih: 'Geçersiz Tarih', saat: 'Geçersiz Saat' };
    }
    return {
      tarih: date.toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }),
      saat: date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    };
  };

  const formatAdetGram = (islem) => {
    const isTL = islem.kategori === 'Döviz' && islem.urun === 'TL - Türk Lirası';
    const isDecimalAllowed = islem.kategori === 'Hurda' || islem.kategori === 'Takı Ürün';
    const gram = islem.gram ? (isDecimalAllowed ? parseFloat(islem.gram).toFixed(2) : parseInt(islem.gram)) : '0';
    const adet = islem.adet ? parseInt(islem.adet) : '0';
    const nakit = parseFloat(islem.nakit) || 0;

    if (islem.kategori === 'Sarrafiye' || islem.kategori === 'Gram Altın' || (islem.kategori === 'Döviz' && !isTL)) {
      return { adet: adet, gram: '0' };
    } else if (islem.kategori === 'Takı Ürün') {
      return { adet: adet, gram: gram };
    } else if (islem.kategori === 'Hurda') {
      return { adet: '0', gram: gram };
    } else if (isTL) {
      return { adet: nakit.toFixed(2), gram: '0' };
    } else if (islem.kategori === 'Genel') {
      return { adet: adet, gram: gram };
    }
    return { adet: '0', gram: '0' };
  };

  const calculateBakiye = () => {
    return islemler.reduce((total, islem) => total + (Number(islem.bakiye) || 0), 0);
  };

  const handleRowClick = (firma) => {
    console.log('Firmaya tıklandı, firmaId:', firma.id);
    setSelectedFirma(firma);
    setFormData({
      sube: firma.sube || '',
      firmaIsmi: firma.firmaIsmi || '',
      vergiNo: firma.vergiNo || '',
      iletisimNo: firma.iletisimNo || '',
      adres: firma.adres || '',
      firmaBilgileri: firma.firmaBilgileri || ''
    });
    setIsEditing(false);
    setError('');
    setSuccess('');

    // Firmaya ait işlemleri çek
    const q = query(
      collection(db, 'subeler', sube, 'islemler'),
      where('firma.id', '==', firma.id)
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const rawData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      const groupMap = new Map();
      rawData.forEach((islem) => {
        if (islem.isMulti && islem.groupId) {
          if (!groupMap.has(islem.groupId)) {
            groupMap.set(islem.groupId, { items: [], timestamp: islem.timestamp });
          }
          groupMap.get(islem.groupId).items.push({ ...islem, no: islem.subNo || 0 });
        } else {
          groupMap.set(islem.id, { items: [{ ...islem, no: 1 }], timestamp: islem.timestamp });
        }
      });

      const sortedGroups = Array.from(groupMap.entries()).sort((a, b) => {
        const timeA = new Date(a[1].timestamp).getTime();
        const timeB = new Date(b[1].timestamp).getTime();
        return timeB - timeA;
      });

      const groupedData = [];
      sortedGroups.forEach(([groupId, group]) => {
        group.items.sort((a, b) => (a.no || 0) - (b.no || 0));
        groupedData.push(...group.items);
      });

      setIslemler(groupedData);
    }, (err) => {
      setError(`İşlem çekme hatası: ${err.message}`);
    });
    return () => unsubscribe();
  };

  const handleCloseModal = () => {
    setSelectedFirma(null);
    setFormData({
      sube: '',
      firmaIsmi: '',
      vergiNo: '',
      iletisimNo: '',
      adres: '',
      firmaBilgileri: ''
    });
    setIslemler([]);
    setIsEditing(false);
    setError('');
    setSuccess('');
    setIsDeleteConfirmOpen(false); // Onay penceresi açıksa kapat
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const docRef = doc(db, 'subeler', sube, 'firmalar', selectedFirma.id);
      await setDoc(docRef, {
        ...formData,
        timestamp: selectedFirma.timestamp
      }, { merge: true });
      setFirmalar(prev => prev.map(f => f.id === selectedFirma.id ? { ...f, ...formData } : f));
      setSelectedFirma({ ...selectedFirma, ...formData });
      setSuccess('Firma bilgileri başarıyla güncellendi.');
      setIsEditing(false);
    } catch (err) {
      setError(`Güncelleme hatası: ${err.message}`);
    }
  };

  // --- YENİ EKLENEN FONKSİYON: Firma silme işlemi ---
  const handleDeleteFirma = async () => {
    try {
        await deleteDoc(doc(db, 'subeler', sube, 'firmalar', selectedFirma.id));
        
        // Listeden silinen firmayı kaldır
        setFirmalar(prev => prev.filter(f => f.id !== selectedFirma.id));
        
        // Modalları kapat
        setIsDeleteConfirmOpen(false);
        handleCloseModal();
    } catch (err) {
        setError(`Firma silinemedi: ${err.message}`);
        setIsDeleteConfirmOpen(false);
    }
  };

  const handleIslemClick = (islem) => {
    setSelectedIslem(islem);
    setEditForm({
      islemNo: islem.islemNo || '',
      musteriIsim: islem.musteri ? `${islem.musteri.isim || ''} ${islem.musteri.soyisim || ''}`.trim() : '',
      firmaIsmi: islem.firma ? islem.firma.firmaIsmi || '' : '',
      kategori: islem.kategori || '',
      urun: islem.urun || '',
      islemTuru: islem.islemTuru || '',
      gram: islem.gram || '',
      adet: islem.adet || '',
      hasFiyati: islem.hasFiyati || '',
      urunBilgisi: islem.urunBilgisi || '',
      barkod: islem.barkod || '',
      islemAciklamasi: islem.islemAciklamasi || '',
      bakiye: islem.bakiye || '',
      nakit: islem.nakit || '',
      havaleEft: islem.havaleEft || '',
      krediKarti: islem.krediKarti || ''
    });
    setIsIslemEditing(false);
    setIslemSuccess('');
    setIslemError('');
  };

  const handleCloseIslemModal = () => {
    setSelectedIslem(null);
    setEditForm(null);
    setIsIslemEditing(false);
    setIslemSuccess('');
    setIslemError('');
  };

  const handleIslemEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'kategori' ? { urun: '' } : {})
    }));
  };

  const handleIslemEditSubmit = async () => {
    setIslemError('');
    setIslemSuccess('');
    try {
      const musteriToSave = editForm.musteriIsim ? {
        isim: editForm.musteriIsim.split(' ').slice(0, -1).join(' ') || editForm.musteriIsim,
        soyisim: editForm.musteriIsim.split(' ').pop() || ''
      } : null;
      const firmaToSave = editForm.firmaIsmi ? { firmaIsmi: editForm.firmaIsmi, id: selectedFirma.id } : null;
      const isDecimalAllowed = editForm.kategori === 'Hurda' || editForm.kategori === 'Takı Ürün';
      const gramValue = isDecimalAllowed ? parseFloat(editForm.gram) || 0 : parseInt(editForm.gram) || 0;
      const adetValue = parseInt(editForm.adet) || 0;
      const toplamTutar = (parseFloat(editForm.nakit) || 0) + (parseFloat(editForm.havaleEft) || 0) + (parseFloat(editForm.krediKarti) || 0);

      const islemData = {
        islemNo: editForm.islemNo,
        kategori: editForm.kategori || null,
        urun: editForm.urun || null,
        islemTuru: editForm.islemTuru || null,
        musteri: musteriToSave,
        firma: firmaToSave,
        barkod: editForm.barkod || null,
        gram: gramValue,
        adet: adetValue,
        urunBilgisi: editForm.urunBilgisi || null,
        islemAciklamasi: editForm.islemAciklamasi || null,
        hasFiyati: parseFloat(editForm.hasFiyati) || 0,
        bakiye: parseFloat(editForm.bakiye) || 0,
        nakit: parseFloat(editForm.nakit) || 0,
        havaleEft: parseFloat(editForm.havaleEft) || 0,
        krediKarti: parseFloat(editForm.krediKarti) || 0,
        toplamTutar: parseFloat(toplamTutar.toFixed(2)),
        islemFisi: selectedIslem.islemFisi || null,
        timestamp: selectedIslem.timestamp,
        sube: sube,
        isMulti: selectedIslem.isMulti,
        groupId: selectedIslem.groupId || null,
        subNo: selectedIslem.subNo || 0
      };

      await updateDoc(doc(db, 'subeler', sube, 'islemler', selectedIslem.id), islemData);
      setIslemSuccess('İşlem başarıyla güncellendi.');
      setIslemler(prev => prev.map(i => i.id === selectedIslem.id ? { ...i, ...islemData } : i));
      setSelectedIslem({ ...selectedIslem, ...islemData });
      setIsIslemEditing(false);
    } catch (err) {
      setIslemError(`İşlem güncellenemedi: ${err.message}`);
    }
  };

  const handleIslemDelete = async () => {
    try {
      // Müşteri listesi ile aynı kural: işlemden sonra günsonu alınmışsa silinmez
      const islemTarihi = selectedIslem.timestamp;
      const gunsonuRef = collection(db, 'subeler', sube, 'gunsonukasa');
      const q = query(gunsonuRef, where('timestamp', '>', islemTarihi), limit(1));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setIslemError("HATA: Bu işlem tarihinden sonra Günsonu Raporu alınmıştır. Geçmişe dönük silme yapılamaz. Lütfen 'Ters İşlem' yapınız.");
        return;
      }

      if (window.confirm('Bu işlemi silmek istediğinize emin misiniz?')) {
        await deleteDoc(doc(db, 'subeler', sube, 'islemler', selectedIslem.id));
        setIslemler(prev => prev.filter(i => i.id !== selectedIslem.id));
        setIslemSuccess('İşlem başarıyla silindi.');
        setSelectedIslem(null);
        setEditForm(null);
        setIsIslemEditing(false);
      }
    } catch (err) {
      setIslemError(`İşlem silinemedi: ${err.message}`);
    }
  };

  const IslemDetailRow = ({ label, value, color }) => (
    <div style={{ marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eef2f7' }}>
      <div style={{ fontSize: '11px', letterSpacing: '0.4px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>
        {label}
      </div>
      <div style={{ marginTop: '3px', fontSize: '15px', fontWeight: 700, color: color || '#1f2937' }}>
        {value || '-'}
      </div>
    </div>
  );

  return (
    <div className="fl-page" style={{
      padding: '16px',
      fontFamily: "'Roboto', sans-serif",
      background: 'radial-gradient(circle at 7% 8%, rgba(183, 125, 47, 0.14) 0%, transparent 30%), radial-gradient(circle at 95% 90%, rgba(15, 39, 68, 0.16) 0%, transparent 34%), linear-gradient(180deg, #f7f9fd 0%, #edf2f9 100%)',
      borderRadius: '14px',
      boxShadow: '0 14px 28px rgba(15, 23, 42, 0.10)',
      border: '1px solid #d5dfec',
      width: '1000px',
      height: '700px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box'
    }}>
      <div className="fl-search-wrap" style={{ marginBottom: '10px', background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)', border: '1px solid #d9e3f0', borderRadius: '10px', padding: '10px 12px', boxShadow: '0 4px 12px rgba(15,23,42,0.05)' }}>
        <input
          className="fl-search-input"
          type="text"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(0);
          }}
          placeholder="Firma İsmi, Vergi No veya İletişim No ara..."
          style={{
            width: '100%',
            padding: '10px 12px',
            fontSize: '15px',
            fontFamily: "'Roboto', sans-serif",
            borderRadius: '9px',
            border: '1px solid #cfd9e5',
            outline: 'none',
            boxSizing: 'border-box',
            backgroundColor: '#fff'
          }}
        />
      </div>
      <div className="fl-table-wrap" style={{ flex: '1', overflowY: 'auto', background: 'linear-gradient(180deg, #ffffff 0%, #f9fbff 100%)', borderRadius: '12px', border: '1px solid #dce5f0', boxShadow: '0 8px 18px rgba(15, 23, 42, 0.07), inset 0 1px 0 rgba(255,255,255,0.7)' }}>
        <table className="fl-table" style={{
          width: '100%',
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
          fontSize: '16px',
          color: '#1f2937'
        }}>
          <thead>
            <tr style={{ height: '48px' }}>
              <th style={{ border: '1px solid #e5e7eb', borderBottom: '2px solid #c58a2f', padding: '8px', textAlign: 'left', width: '10%', fontSize: '14px', letterSpacing: '0.3px' }}>No</th>
              <th style={{ border: '1px solid #e5e7eb', borderBottom: '2px solid #c58a2f', padding: '8px', textAlign: 'left', width: '45%', fontSize: '14px', letterSpacing: '0.3px' }}>Firma İsmi</th>
              <th style={{ border: '1px solid #e5e7eb', borderBottom: '2px solid #c58a2f', padding: '8px', textAlign: 'left', width: '45%', fontSize: '14px', letterSpacing: '0.3px' }}>İletişim Numarası</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((firma) => (
              <tr
                key={firma.id}
                onClick={() => handleRowClick(firma)}
                style={{ cursor: 'pointer', transition: 'background-color 0.2s', height: '46px' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#edf5ff'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
              >
                <td style={{ border: '1px solid #e5e7eb', padding: '8px', textAlign: 'left', fontSize: '15px', fontWeight: 800, color: '#243b53' }}>{firma.no}</td>
                <td style={{ border: '1px solid #e5e7eb', padding: '8px', textAlign: 'left', fontSize: '15px', fontWeight: 700 }}>
                  {firma.firmaIsmi || 'Belirtilmemiş'}
                </td>
                <td style={{ border: '1px solid #e5e7eb', padding: '8px', textAlign: 'left', fontSize: '15px', color: '#0f4c81' }}>
                  {firma.iletisimNo || 'Belirtilmemiş'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ListPagination
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        totalItems={filteredFirmalar.length}
        itemsPerPage={itemsPerPage}
        itemLabel="firma"
      />
      <style>
        {`
          .fl-search-input:focus {
            border-color: #b77d2f !important;
            box-shadow: 0 0 0 3px rgba(183, 125, 47, 0.16);
          }
          .fl-table th {
            background: linear-gradient(180deg, #fbfdff 0%, #f2f7ff 100%);
            color: #0f172a;
            font-weight: 800;
          }
          .fl-table tbody tr:nth-child(odd) td {
            background-color: #fcfdff;
          }
          .fl-table-wrap::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          .fl-table-wrap::-webkit-scrollbar-thumb {
            background: #c8d5e8;
            border-radius: 20px;
          }

          /* --- MOBİL: Firma Listesi (masaüstü inline stillere dokunulmaz) --- */
          @media (max-width: 480px) {
            .fl-page {
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              padding: 0 !important;
              overflow-x: hidden !important;
              box-sizing: border-box !important;
            }

            .fl-search-wrap {
              padding: 8px 10px !important;
              margin-bottom: 8px !important;
            }

            .fl-search-input {
              font-size: 16px !important;
              padding: 10px !important;
            }

            .fl-table-wrap {
              flex: none !important;
              max-height: none !important;
              overflow-x: auto !important;
              overflow-y: visible !important;
              -webkit-overflow-scrolling: touch;
            }

            .fl-table {
              font-size: 14px !important;
              min-width: 0 !important;
            }

            .fl-table th,
            .fl-table td {
              padding: 7px 6px !important;
              font-size: 13px !important;
              word-break: break-word;
            }

            .fl-table th:first-child,
            .fl-table td:first-child {
              width: 12% !important;
            }

            .fl-table th:nth-child(2),
            .fl-table td:nth-child(2) {
              width: 44% !important;
            }

            .fl-table th:nth-child(3),
            .fl-table td:nth-child(3) {
              width: 44% !important;
            }

            .fl-firma-modal {
              flex-direction: column !important;
              width: calc(100vw - 48px) !important;
              max-width: calc(100vw - 48px) !important;
              max-height: 92svh !important;
              padding: 12px !important;
              gap: 10px !important;
              overflow-y: auto !important;
              -webkit-overflow-scrolling: touch;
            }

            .fl-firma-panel {
              width: 100% !important;
              min-width: 0 !important;
              height: auto !important;
              max-height: none !important;
              padding: 12px !important;
            }

            .fl-firma-islemler {
              max-height: min(320px, 42vh) !important;
            }

            .fl-firma-actions {
              display: flex !important;
              flex-wrap: wrap !important;
              gap: 8px !important;
            }

            .fl-firma-actions button {
              margin-left: 0 !important;
            }

            .fl-firma-modal-footer {
              width: 100% !important;
              margin-top: 0 !important;
              justify-content: stretch !important;
            }

            .fl-firma-modal-footer button {
              width: 100% !important;
            }

            .fl-firma-info li {
              flex-direction: column !important;
              align-items: stretch !important;
              gap: 4px !important;
            }

            .fl-firma-info li strong {
              min-width: 0 !important;
              font-size: 14px !important;
            }

            .fl-firma-info li span,
            .fl-firma-info li input {
              font-size: 15px !important;
            }

            .fl-islemler-table {
              font-size: 13px !important;
            }

            .fl-islemler-table th,
            .fl-islemler-table td {
              padding: 5px 4px !important;
              font-size: 12px !important;
              word-break: break-word;
            }

            .fl-delete-modal {
              width: min(calc(100vw - 28px), 340px) !important;
              padding: 16px !important;
            }

            .fl-islem-modal {
              width: calc(100vw - 16px) !important;
              max-width: calc(100vw - 16px) !important;
              max-height: 92svh !important;
            }

            .fl-islem-modal-header {
              flex-wrap: wrap !important;
              gap: 8px !important;
              padding: 10px 12px !important;
            }

            .fl-islem-modal-header > div:first-child {
              font-size: 18px !important;
            }

            .fl-islem-modal-body {
              padding: 10px !important;
              max-height: calc(92svh - 120px) !important;
              overflow-y: auto !important;
              -webkit-overflow-scrolling: touch;
            }

            .fl-islem-grid-3,
            .fl-islem-grid-2 {
              grid-template-columns: 1fr !important;
              gap: 10px !important;
            }

            .fl-islem-modal-actions {
              flex-wrap: wrap !important;
              justify-content: stretch !important;
              gap: 8px !important;
            }

            .fl-islem-modal-actions button {
              flex: 1 1 calc(50% - 4px) !important;
              min-width: 0 !important;
              font-size: 13px !important;
              padding: 8px 10px !important;
            }
          }
        `}
      </style>
      <Modal
        open={!!selectedFirma}
        onClose={handleCloseModal}
        aria-labelledby="firma-detay-modal"
      >
        <Box className="fl-firma-modal" style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'linear-gradient(180deg, #fdfefe 0%, #f3f7ff 100%)',
          borderRadius: '14px',
          boxShadow: '0 16px 34px rgba(15, 23, 42, 0.20)',
          border: '1px solid #d6e1ef',
          padding: '30px',
          width: '100%',
          maxWidth: '1210px',
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
          fontFamily: "'Roboto', sans-serif",
          maxHeight: '80vh',
          overflowY: 'auto'
        }}>
          {selectedFirma && (
            <>
              <div className="fl-firma-panel fl-firma-info" style={{
                background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 8px 20px rgba(15, 23, 42, 0.10)',
                border: '1px solid #dce5f0',
                width: '500px',
                height: '600px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
                boxSizing: 'border-box'
              }}>
                <Typography id="firma-detay-modal" variant="h6" style={{ fontSize: '24px', color: '#102a43', fontWeight: '800', marginBottom: '10px', letterSpacing: '0.2px' }}>
                  Firma Detayları
                </Typography>
                {success && <Alert severity="success" style={{ fontSize: '16px', marginBottom: '10px' }}>{success}</Alert>}
                {error && <Alert severity="error" style={{ fontSize: '16px', marginBottom: '10px' }}>{error}</Alert>}
                <div className="fl-firma-actions" style={{ marginBottom: '10px' }}>
                  <Button
                    onClick={() => setIsEditing(!isEditing)}
                    style={{
                      padding: '6px 12px',
                      fontSize: '14px',
                      fontFamily: "'Roboto', sans-serif",
                      background: isEditing ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : 'linear-gradient(135deg, #16365c 0%, #0f2744 100%)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    {isEditing ? 'İptal' : 'Düzenle'}
                  </Button>
                  
                  {/* --- FİRMA SİL BUTONU --- */}
                  <Button
                    onClick={() => setIsDeleteConfirmOpen(true)}
                    style={{
                      marginLeft: '10px',
                      padding: '6px 12px',
                      fontSize: '14px',
                      fontFamily: "'Roboto', sans-serif",
                      background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    Sil
                  </Button>

                  {isEditing && (
                    <Button
                      onClick={handleSave}
                      style={{
                        marginLeft: '10px',
                        padding: '6px 12px',
                        fontSize: '14px',
                        fontFamily: "'Roboto', sans-serif",
                        background: 'linear-gradient(135deg, #0f8b45 0%, #0c6e37 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer'
                      }}
                    >
                      Kaydet
                    </Button>
                  )}
                </div>
                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0, 
                  margin: 0, 
                  fontSize: '16px', 
                  fontWeight: '400', 
                  color: '#1f2937',
                  flex: '1'
                }}>
                  {[
                    { label: 'Şube', name: 'sube' },
                    { label: 'Firma İsmi', name: 'firmaIsmi' },
                    { label: 'Vergi No', name: 'vergiNo' },
                    { label: 'İletişim No', name: 'iletisimNo' },
                    { label: 'Adres', name: 'adres' },
                    { label: 'Firma Bilgileri', name: 'firmaBilgileri' }
                  ].map((field, index) => (
                    <li key={field.name} style={{ 
                      padding: '6px 0', 
                      borderBottom: index === 5 ? 'none' : '1px solid #e5e7eb',
                      display: 'flex', 
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <strong style={{ fontWeight: '600', color: '#111827', minWidth: '120px', fontSize: '16px' }}>{field.label}:</strong> 
                      {isEditing ? (
                        <input
                          type="text"
                          name={field.name}
                          value={formData[field.name]}
                          onChange={handleInputChange}
                          style={{
                            width: '100%',
                            padding: '4px',
                            fontSize: '16px',
                            fontFamily: "'Roboto', sans-serif",
                            border: '1px solid #e5e7eb',
                            borderRadius: '4px',
                            outline: 'none'
                          }}
                        />
                      ) : (
                        <span>{selectedFirma[field.name] || 'Belirtilmemiş'}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="fl-firma-panel fl-firma-islemler" style={{
                background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 8px 20px rgba(15, 23, 42, 0.10)',
                border: '1px solid #dce5f0',
                width: '700px',
                height: '600px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxSizing: 'border-box'
              }}>
                <Typography variant="h6" style={{ fontSize: '24px', color: '#102a43', fontWeight: '800', marginBottom: '10px' }}>
                  İşlemler
                </Typography>
                <div style={{ flex: '1', overflowY: 'auto' }}>
                  <table className="fl-islemler-table" style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    tableLayout: 'fixed',
                    fontSize: '16px',
                    color: '#1f2937'
                  }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left', width: '15%' }}>No</th>
                        <th style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left', width: '25%' }}>Tarih</th>
                        <th style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left', width: '25%' }}>İşlem Türü</th>
                        <th style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left', width: '25%' }}>Ürün</th>
                        <th style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left', width: '25%' }}>Toplam Tutar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {islemler.length > 0 ? (
                        islemler.map((islem) => {
                          const { tarih } = formatTimestamp(islem.timestamp);
                          return (
                            <tr 
                              key={islem.id} 
                              style={{ transition: 'background-color 0.2s', cursor: 'pointer' }}
                              onClick={() => handleIslemClick(islem)}
                              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#edf5ff'}
                              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                            >
                              <td style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left' }}>{islem.islemNo || islem.no}</td>
                              <td style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left' }}>{tarih}</td>
                              <td style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left' }}>
                                {islem.islemTuru || 'Belirtilmemiş'}
                              </td>
                              <td style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left' }}>
                                {islem.urun || 'Belirtilmemiş'}
                              </td>
                              <td style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'left' }}>
                                {islem.toplamTutar || '0'} TL
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ border: '1px solid #e5e7eb', padding: '6px', textAlign: 'center', color: '#4b5563' }}>
                            İşlem bulunamadı.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div style={{
                  padding: '6px 0',
                  borderTop: '1px solid #e5e7eb',
                  textAlign: 'right',
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  Toplam Bakiye: <span style={{ color: calculateBakiye() >= 0 ? '#15803d' : '#dc2626' }}>
                    {calculateBakiye()} TL
                  </span>
                </div>
              </div>
            </>
          )}
          <div className="fl-firma-modal-footer" style={{ display: 'flex', gap: '15px', marginTop: '15px', justifyContent: 'center' }}>
            <Button
              onClick={handleCloseModal}
              style={{
                borderColor: '#dc2626',
                color: '#9b1526',
                fontSize: '14px',
                fontFamily: "'Roboto', sans-serif",
                fontWeight: '600',
                borderRadius: '8px',
                padding: '8px 18px',
                textTransform: 'none',
                border: '1px solid #9b1526',
                background: '#fff'
              }}
            >
              Kapat
            </Button>
          </div>
        </Box>
      </Modal>

      {/* --- FİRMA SİLME ONAY MODALI --- */}
      <Modal
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        aria-labelledby="silme-onay-modal"
      >
        <Box className="fl-delete-modal" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%)',
            borderRadius: '12px',
            boxShadow: '0 14px 28px rgba(15, 23, 42, 0.2)',
            border: '1px solid #dce5f0',
            padding: '20px',
            width: '400px',
            fontFamily: "'Roboto', sans-serif",
            textAlign: 'center'
        }}>
            <Typography variant="h6" style={{ marginBottom: '20px', color: '#1f2937' }}>
                Firmayı silmek istediğinize emin misiniz?
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                <Button
                    onClick={handleDeleteFirma}
                    style={{
                        background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                        color: '#fff',
                        fontWeight: '600',
                        textTransform: 'none',
                        padding: '8px 20px',
                        borderRadius: '8px'
                    }}
                >
                    Evet, Sil
                </Button>
                <Button
                    onClick={() => setIsDeleteConfirmOpen(false)}
                    style={{
                        background: 'linear-gradient(180deg, #eef2f8 0%, #e2e8f0 100%)',
                        color: '#374151',
                        fontWeight: '600',
                        textTransform: 'none',
                        padding: '8px 20px',
                        borderRadius: '8px'
                    }}
                >
                    Vazgeç
                </Button>
            </div>
        </Box>
      </Modal>

      <Modal open={!!selectedIslem} onClose={handleCloseIslemModal} aria-labelledby="islem-detay-modal">
        <Box className="fl-islem-modal" style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: '#f6f8fb',
          borderRadius: '12px',
          boxShadow: '0 14px 30px rgba(15, 23, 42, 0.20)',
          border: '1px solid #d9e3ef',
          width: '100%',
          maxWidth: '980px',
          fontFamily: "'Roboto', sans-serif",
          maxHeight: '88vh',
          overflow: 'hidden'
        }}>
          {selectedIslem && editForm && (
            <div style={{ width: '100%' }}>
              <div className="fl-islem-modal-header" style={{ background: 'linear-gradient(90deg, #132b4a 0%, #1e3657 58%, #b3681f 100%)', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700, fontSize: '22px' }}>İşlem detayı</div>
                <div style={{ background: '#fff', color: '#0f172a', border: '1px solid #d4d8de', borderRadius: '12px', padding: '4px 10px', fontSize: '12px', fontWeight: 800 }}>
                  No: {selectedIslem.islemNo || '-'}
                </div>
              </div>

              <div className="fl-islem-modal-body" style={{ padding: '12px' }}>
                {islemSuccess && <Alert severity="success" style={{ fontSize: '14px', marginBottom: '8px' }}>{islemSuccess}</Alert>}
                {islemError && <Alert severity="error" style={{ fontSize: '14px', marginBottom: '8px' }}>{islemError}</Alert>}

                {isIslemEditing ? (
                  <div className="fl-islem-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', maxHeight: 'none', overflowY: 'visible', paddingTop: '8px', paddingRight: '6px' }}>
                    <TextField label="İşlem No" name="islemNo" value={editForm.islemNo} onChange={handleIslemEditChange} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} disabled />
                    <TextField label="Müşteri (İsim Soyisim)" name="musteriIsim" value={editForm.musteriIsim} onChange={handleIslemEditChange} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="Firma İsmi" name="firmaIsmi" value={editForm.firmaIsmi} onChange={handleIslemEditChange} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <Select name="kategori" value={editForm.kategori} onChange={handleIslemEditChange} displayEmpty fullWidth variant="outlined" style={{ fontSize: '16px', height: '48px', borderRadius: '6px' }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }}>
                      <MenuItem value="">Kategori Seç</MenuItem>{kategoriler.map((kat) => (<MenuItem key={kat} value={kat}>{kat}</MenuItem>))}
                    </Select>
                    <Select name="urun" value={editForm.urun} onChange={handleIslemEditChange} displayEmpty fullWidth variant="outlined" style={{ fontSize: '16px', height: '48px', borderRadius: '6px' }} disabled={!editForm.kategori || editForm.kategori === 'Genel'} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }}>
                      <MenuItem value="">Ürün Seç</MenuItem>{editForm.kategori && urunlerListesi[editForm.kategori]?.map((urun) => (<MenuItem key={urun} value={urun}>{urun}</MenuItem>))}
                    </Select>
                    <Select name="islemTuru" value={editForm.islemTuru} onChange={handleIslemEditChange} displayEmpty fullWidth variant="outlined" style={{ fontSize: '16px', height: '48px', borderRadius: '6px' }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }}>
                      <MenuItem value="">İşlem Türü Seç</MenuItem>{islemTurleri.map((tur) => (<MenuItem key={tur} value={tur}>{tur}</MenuItem>))}
                    </Select>
                    <TextField label="Gram" name="gram" value={editForm.gram} onChange={handleIslemEditChange} type="number" step={editForm.kategori === 'Hurda' || editForm.kategori === 'Takı Ürün' ? '0.01' : '1'} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} disabled={editForm.kategori === 'Sarrafiye' || editForm.kategori === 'Gram Altın' || editForm.kategori === 'Döviz' || !editForm.kategori} />
                    <TextField label="Adet" name="adet" value={editForm.adet} onChange={handleIslemEditChange} type="number" fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} disabled={editForm.kategori === 'Hurda' || (editForm.kategori === 'Döviz' && editForm.urun === 'TL - Türk Lirası') || !editForm.kategori} />
                    <TextField label="Has Fiyatı" name="hasFiyati" value={editForm.hasFiyati} onChange={handleIslemEditChange} type="number" step="0.01" fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} disabled={editForm.urun === 'TL - Türk Lirası'} />
                    <TextField label="Ürün Bilgisi" name="urunBilgisi" value={editForm.urunBilgisi} onChange={handleIslemEditChange} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="Barkod" name="barkod" value={editForm.barkod} onChange={handleIslemEditChange} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="İşlem Açıklaması" name="islemAciklamasi" value={editForm.islemAciklamasi} onChange={handleIslemEditChange} multiline rows={3} fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="Bakiye" name="bakiye" value={editForm.bakiye} onChange={handleIslemEditChange} type="number" step="0.01" fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="Nakit" name="nakit" value={editForm.nakit} onChange={handleIslemEditChange} type="number" step="0.01" fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="Havale/EFT" name="havaleEft" value={editForm.havaleEft} onChange={handleIslemEditChange} type="number" step="0.01" fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                    <TextField label="Kredi Kartı" name="krediKarti" value={editForm.krediKarti} onChange={handleIslemEditChange} type="number" step="0.01" fullWidth variant="outlined" InputProps={{ style: { fontSize: '16px', height: '48px', borderRadius: '6px' } }} InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: '600', color: '#1e3a8a' } }} sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' } }} />
                  </div>
                ) : (
                  <div className="fl-islem-grid-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                      <div style={{ background: '#e9f4fb', borderBottom: '1px solid #d8e9f8', padding: '10px 12px', fontWeight: 700, color: '#1565c0' }}>Firma & özet</div>
                      <div style={{ padding: '10px 12px' }}>
                        <IslemDetailRow label="Firma" value={editForm.firmaIsmi} />
                        <IslemDetailRow label="İşlem tarihi" value={formatTimestamp(selectedIslem.timestamp).tarih} />
                        <IslemDetailRow label="İşlem türü" value={selectedIslem.islemTuru} color={selectedIslem.islemTuru === 'Satış' ? '#0f8b45' : '#b45309'} />
                        <IslemDetailRow label="İşlem no" value={selectedIslem.islemNo} />
                      </div>
                    </div>
                    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                      <div style={{ background: '#fff7e8', borderBottom: '1px solid #fde7c1', padding: '10px 12px', fontWeight: 700, color: '#e65100' }}>Ürün bilgileri</div>
                      <div style={{ padding: '10px 12px' }}>
                        <IslemDetailRow label="Kategori" value={selectedIslem.kategori} />
                        <IslemDetailRow label="Ürün" value={selectedIslem.urun} />
                        <IslemDetailRow label="Miktar" value={`${formatAdetGram(selectedIslem).gram} Gr / ${formatAdetGram(selectedIslem).adet} Adet`} />
                        <IslemDetailRow label="Barkod" value={selectedIslem.barkod} />
                        <div style={{ marginTop: '8px', background: '#fff8e1', border: '1px dashed #ffc76a', borderRadius: '8px', padding: '8px', minHeight: '64px' }}>
                          <div style={{ fontSize: '11px', fontWeight: 700, color: '#b45309', marginBottom: '3px' }}>İşlem açıklaması</div>
                          <div style={{ fontSize: '13px', color: '#374151' }}>{selectedIslem.urunBilgisi || selectedIslem.islemAciklamasi || 'Ek açıklama girilmemiş.'}</div>
                        </div>
                      </div>
                    </div>
                    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                      <div style={{ background: '#edf9f1', borderBottom: '1px solid #d3eed9', padding: '10px 12px', fontWeight: 700, color: '#1b5e20' }}>Finansal detaylar</div>
                      <div style={{ padding: '10px 12px' }}>
                        <IslemDetailRow label="Has fiyatı" value={`${selectedIslem.hasFiyati || 0} TL`} />
                        <IslemDetailRow label="Nakit" value={`${selectedIslem.nakit || 0} TL`} />
                        <IslemDetailRow label="Havale / EFT" value={`${selectedIslem.havaleEft || 0} TL`} />
                        <IslemDetailRow label="Kredi kartı" value={`${selectedIslem.krediKarti || 0} TL`} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #e5e7eb' }}>
                          <span style={{ fontSize: '12px', fontWeight: 700, color: '#6b7280' }}>İşlem tutarı:</span>
                          <span style={{ fontSize: '20px', fontWeight: 900, color: '#1f2937' }}>{selectedIslem.toplamTutar || 0} TL</span>
                        </div>
                        <div style={{ marginTop: '8px', background: (parseFloat(selectedIslem.bakiye) || 0) > 0 ? '#ffebee' : '#f1f8e9', border: `1px solid ${(parseFloat(selectedIslem.bakiye) || 0) > 0 ? '#ef9a9a' : '#a5d6a7'}`, borderRadius: '8px', padding: '8px', display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: '12px', fontWeight: 700, color: (parseFloat(selectedIslem.bakiye) || 0) > 0 ? '#b91c1c' : '#166534' }}>Kalan bakiye:</span>
                          <span style={{ fontSize: '18px', fontWeight: 900, color: (parseFloat(selectedIslem.bakiye) || 0) > 0 ? '#b91c1c' : '#166534' }}>{selectedIslem.bakiye || 0} TL</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="fl-islem-modal-actions" style={{ display: 'flex', gap: '12px', marginTop: '12px', justifyContent: 'flex-end', borderTop: '1px solid #e3e9f2', paddingTop: '10px' }}>
                  {isIslemEditing ? (
                    <>
                      <Button onClick={() => setIsIslemEditing(false)} style={{ borderColor: '#dc2626', color: '#dc2626', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: '600', borderRadius: '8px', padding: '7px 16px', textTransform: 'none', border: '1px solid #dc2626', background: '#fff' }}>İptal</Button>
                      <Button onClick={handleIslemEditSubmit} style={{ background: 'linear-gradient(135deg, #16365c 0%, #0f2744 100%)', color: '#fff', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: '600', borderRadius: '8px', padding: '7px 16px', textTransform: 'none' }}>Kaydet</Button>
                    </>
                  ) : (
                    <>
                      <Button onClick={handleIslemDelete} style={{ background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)', color: '#fff', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: '600', borderRadius: '8px', padding: '7px 16px', textTransform: 'none' }}>Sil</Button>
                      <Button onClick={() => setIsIslemEditing(true)} style={{ background: 'linear-gradient(135deg, #16365c 0%, #0f2744 100%)', color: '#fff', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: '600', borderRadius: '8px', padding: '7px 16px', textTransform: 'none' }}>Düzenle</Button>
                      <Button onClick={handleCloseIslemModal} style={{ borderColor: '#27476b', color: '#27476b', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: '600', borderRadius: '8px', padding: '7px 16px', textTransform: 'none', border: '1px solid #27476b', background: '#fff' }}>Kapat</Button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default FirmaListesi;